// extracted by mini-css-extract-plugin
module.exports = {"container":"videoSection_container__uTip6","isVideo":"videoSection_isVideo__2UWTn"};
    if(module.hot) {
      // 1783592037796
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  